// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"4730":"4c67d4dd312d3c3c","8968":"55adb7df6c770ffd"}[chunkId] + ".js";
};